import React, { Component } from 'react';
import { Upload, Modal, Tooltip, Button } from 'antd';
import { UploadOutlined, PlusOutlined, CloudUploadOutlined } from '@ant-design/icons';
import formDataPostService from '../../../services/httpformData';

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

class Uploadlayer extends Component {


    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            loading: false,
            previewVisible: false,
            previewImage: '',
            previewTitle: '',
            fileList: [],
            docTypes: []
        };
    }
    componentDidMount() {
        console.log('upload:', this.props)
        let { docTypes } = this.props
        this.setState({ docTypes: docTypes ? docTypes : [] })
    }
    handleCancel = () => { this.setState({ previewVisible: false }) };

    handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
            previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
        });
    };

    uploadDoc = (evt) => {
        var filename = evt.target.files[0];
        var form_data = new FormData();
        form_data.append('upfile', filename);
        form_data.append("umr", 'UMR21220001983');
        form_data.append("ip", 'IP2122000684');
        // To check for the values are present or not
        for (var key of form_data.entries()) {
            console.log(key[0] + ', ' + key[1]);
        }
        console.log('filename:', filename);

        formDataPostService('fileUpload', 'POST', form_data).then(res => {
            console.log('response:', res);
        })
    }
    handleChange = ({ fileList }) => {
        console.log('filelist', fileList)

        let file = null,
            file_type = null,
            file_name = null,
            file_size = null;
        fileList.map(async (item, key) => {
            // fileList[key]['status'] = 'done';
            // fileList[key]['base_64'] = await getBase64(file.originFileObj);            
            file = item.originFileObj;
            file_type = item.type;
            file_name = item.name;
            file_size = item.size;
            // check file type
            const isJpgOrPngOrPdf = file_type == 'image/png' || file_type == 'image/jpg' || file_type == 'image/jpeg' || file_type == 'application/pdf';
            if (!isJpgOrPngOrPdf) {
                Modal.error({
                    title: `(${file_name}) is invalid file.`,
                    content: `Please, upload the following extensions files (.png/.jpg/.pdf) smaller than 2MB only.`,
                    zIndex: '1022'
                });
            }
            // check file size        
            const isLt2M = file_size / 1024 / 1024 < 2;
            if (!isLt2M) {
                Modal.error({
                    title: `(${file_name}) is invalid file.`,
                    content: `Please, upload the file smaller than 2MB only.`,
                    zIndex: '1022'
                });
            }

            if (isJpgOrPngOrPdf && isLt2M) {
                // Modal.success({
                //     title: `success`,
                //     content: ``,
                //     zIndex: '1022'
                // });
                console.log('check',isJpgOrPngOrPdf, isLt2M)
                this.submit(file)
            }
        });


        // fileList.map(async (file, key) => {
        //     fileList[key]['status'] = 'done';
        //     fileList[key]['base_64'] = await getBase64(file.originFileObj);
        // });


        // this.setState((state) => ({ fileList }), () => {
        //     let { value, error,fileList } = this.state;
        //     let { feild_data } = this.props;
        //     feild_data['value'] = fileList;
        //     feild_data['error'] = error;
        //     this.props.inputChange(feild_data)
        // })
    };

    // 
    submit = (file) => {
        let user_data = null
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        let { umr_no, ip_no } = this.props
        var form_data = new FormData();
        form_data.append('upfile', file);
        form_data.append("umr", umr_no);
        form_data.append("ip", ip_no);
        form_data.append("file_uploading_id", null);
        form_data.append("document_short_code", 'CIC');
        form_data.append("document_id", '2');
        form_data.append("unit_id", user_data['unitid']);
        // To check for the values are present or not
        for (var key of form_data.entries()) {
            console.log(key[0] + ', ' + key[1]);
        }
        console.log('form_data:', form_data);

        formDataPostService('fileUpload', 'POST', form_data).then(res => {
            console.log('fileupload response:', res);
            if(res.status){                
                Modal.success({
                        title: `success`,
                        content: `${res.message}`,
                        zIndex: '1022'
                    });
            }else{
                Modal.error({
                    title: `Failure`,
                    content: `${res.message}`,
                    zIndex: '1022'
                });
            }
            
        })
    }
    render() {
        const { previewVisible, previewImage, fileList, previewTitle, docTypes } = this.state;
        const uploadButton = (
            <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
            </div>
        );

        return (
            <div style={{ width: '50px' }}>
                {/* <Upload
                    action={null}
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={this.handlePreview}
                    onChange={this.handleChange}
                >
                    {fileList.length >= 8 ? null : uploadButton}
                </Upload>
                <Modal
                    zIndex={1060}
                    visible={previewVisible}
                    title={previewTitle}
                    footer={null}
                    onCancel={this.handleCancel}
                >
                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                </Modal> */}

                {/*antd hold this */}
                <Upload action={null} fileList={fileList} onChange={this.handleChange} maxCount={1} multiple >
                    <Tooltip title="Click here to Upload">
                        <Button icon={<CloudUploadOutlined />} ></Button>
                    </Tooltip>
                </Upload>

                {/* working input */}
                {/* <input type="file" name="uploadfile" id='file' onChange={this.uploadDoc.bind(this)} />

                <label for="file" class="btn-3">
                    <Tooltip title="Click here to Upload">
                        <img src="/assets/images/upload.png" alt="Upload"></img>
                    </Tooltip>
                </label> */}
            </div>
        );
    }


    // handleCancel = () => this.setState({ previewVisible: false });

    // handlePreview = async file => {
    //     if (!file.url && !file.preview) {
    //         file.preview = await getBase64(file.originFileObj);
    //     }

    //     this.setState({
    //         previewImage: file.url || file.preview,
    //         previewVisible: true,
    //         previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
    //     });
    // };

    // // handleChange = ({ fileList }) => this.setState({ fileList });

    // render() {
    //     const { previewVisible, previewImage, fileList, previewTitle } = this.state;
    //     console.log(fileList);
    //     const uploadButton = (
    //         <div>
    //             <PlusOutlined />
    //             <div className="ant-upload-text">Choose File</div>
    //         </div>
    //     );
    //     return (
    //         <div className="clearfix px-3 mx-auto">
    //             <Upload
    //                 listType="picture-card"
    //                 fileList={fileList}
    //                 onPreview={this.handlePreview}
    //                 onChange={this.inputChange}
    //             >
    //                 {fileList.length >= 4 ? null : uploadButton}
    //             </Upload>
    //             <Modal
    //                 visible={previewVisible}
    //                 title={previewTitle}
    //                 footer={null}
    //                 onCancel={this.handleCancel}
    //             >
    //                 <img alt="example" style={{ width: '100%' }} src={previewImage} />
    //             </Modal>
    //         </div>
    //     );
    // }
}

export default Uploadlayer;